var _linearGradient, _linearGradient2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAzurepipelinesSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    x: 1.455,
    y: 1.455,
    width: 29.091,
    height: 29.091,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.7,20.974l1.464-1.565,1.819,1.819L7.5,22.707,9.293,24.5l1.479-1.479L12.6,24.852,11.151,26.3l4.242,4.242h6.667a1.212,1.212,0,0,0,1.212-1.212v-9.7l6.195-4.129a2.425,2.425,0,0,0,1.078-2.016V2.667a1.212,1.212,0,0,0-1.212-1.212H18.509a2.425,2.425,0,0,0-2.016,1.078L12.364,8.727h-9.7A1.212,1.212,0,0,0,1.455,9.94v6.666Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.636,23.273H1.455v7.273H8.727V28.364H3.636Z",
    style: {
      fill: "#fff"
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.069,
    y1: 31.569,
    x2: 1.069,
    y2: 31.569,
    gradientTransform: "matrix(0, 29.091, 29.091, 0, -902.364, -0.545)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.069,
    y1: 31.194,
    x2: 1.069,
    y2: 31.194,
    xlinkHref: "#b"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_azurepipelines") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.455,23.273H3.636v5.091H8.727v2.182H1.455Z",
    style: {
      fill: "#91b0f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.455,9.939v6.667L5.7,20.974,7.515,19.03l5.455,5.455L11.151,26.3l4.242,4.242h6.667a1.212,1.212,0,0,0,1.212-1.212v-9.7L12.364,8.727h-9.7A1.212,1.212,0,0,0,1.455,9.939Z",
    style: {
      fill: "#0f46bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,18.249,17.212,1.455H30.545V14.788L13.751,26Z",
    style: {
      fill: "#062aa9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7,18.952a1.212,1.212,0,0,1-.151-1.53l9.94-14.889a2.424,2.424,0,0,1,2.016-1.078H29.333a1.212,1.212,0,0,1,1.212,1.212V13.492a2.424,2.424,0,0,1-1.078,2.016l-14.889,9.94a1.212,1.212,0,0,1-1.53-.151Z",
    style: {
      fill: "#2560e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,22.707l9.255-9.255,1.792,1.792L9.293,24.5Z",
    style: {
      fill: "#0a44c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,22.707l9.255-9.255,1.792,1.792L9.293,24.5Z",
    style: {
      fill: "#729af2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.772,23.02,8.98,21.228l7.776-7.775,1.792,1.792Z",
    style: {
      fill: "#4c80f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.273,12.364a3.636,3.636,0,1,0-3.636-3.636A3.636,3.636,0,0,0,23.273,12.364Z",
    style: {
      fill: "#0a44c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.273,12.364a3.636,3.636,0,1,0-3.636-3.636A3.636,3.636,0,0,0,23.273,12.364Z",
    style: {
      fill: "#91b0f2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.20000000298023224
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.7,20.974l1.464-1.565,1.819,1.819L7.5,22.707,9.293,24.5l1.479-1.479L12.6,24.852,11.151,26.3l4.242,4.242h6.667a1.212,1.212,0,0,0,1.212-1.212v-9.7l6.195-4.129a2.425,2.425,0,0,0,1.078-2.016V2.667a1.212,1.212,0,0,0-1.212-1.212H18.509a2.425,2.425,0,0,0-2.016,1.078L12.364,8.727h-9.7A1.212,1.212,0,0,0,1.455,9.94v6.666Z",
    style: {
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.636,23.273H1.455v7.273H8.727V28.364H3.636Z",
    style: {
      fill: "url(#c)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzurepipelinesSvgrepoCom);
export default __webpack_public_path__ + "static/media/azurepipelines-svgrepo-com.5117ed9f1084c0aecf0cf1cf1cf9ccca.svg";
export { ForwardRef as ReactComponent };